const STARTING_COUNTS = { p: 8, n: 2, b: 2, r: 2, q: 1 };
const PIECE_VALUE = { p: 1, n: 3, b: 3, r: 5, q: 9 };

/** Captured pieces + material balance, computed straight from a FEN —
 * no dependency on move-history format, always accurate for the
 * current position. */
export function getCapturedPieces(fen) {
  const placement = fen.split(' ')[0];
  const onBoard = { w: { p: 0, n: 0, b: 0, r: 0, q: 0 }, b: { p: 0, n: 0, b: 0, r: 0, q: 0 } };
  for (const ch of placement) {
    if (/[pnbrq]/.test(ch)) onBoard.b[ch]++;
    else if (/[PNBRQ]/.test(ch)) onBoard.w[ch.toLowerCase()]++;
  }
  const capturedByWhite = []; // black pieces white has captured
  const capturedByBlack = []; // white pieces black has captured
  let materialDiff = 0; // positive = white is ahead
  for (const type of ['q', 'r', 'b', 'n', 'p']) {
    const blackLost = STARTING_COUNTS[type] - onBoard.b[type];
    const whiteLost = STARTING_COUNTS[type] - onBoard.w[type];
    for (let i = 0; i < blackLost; i++) capturedByWhite.push(type);
    for (let i = 0; i < whiteLost; i++) capturedByBlack.push(type);
    materialDiff += (blackLost - whiteLost) * PIECE_VALUE[type];
  }
  return { capturedByWhite, capturedByBlack, materialDiff };
}
